import rill from "rill";
import set from "@rill/set";
import ProgramLibrary from "./program-library";
import ProgramOverview from "./program-overview";
import ProgramPreview from "./program-preview";

const ProgramLibraryController = (app) => {
  app.at(
    "/program-library/*",
    rill()
      .use(set("heading", ["Athlete", "Program Library"]))
      .setup(ProgramLibrary)
      .setup(ProgramOverview)
      .setup(ProgramPreview)
  );
};

export default ProgramLibraryController;
